const IcDropdownChecked = (props: any) => {
  return (<div {...props}>
    <svg viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5 9L6.99722 11.5L11 6.5" stroke="#00CC9C" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  </div>)
}

export default IcDropdownChecked;